<template>
  <div>
    <div class="filtrateBox">
      <div class="List">
        <div
          :class="['grade', yearIndex == index ? 'gradeActive' : '']"
          :style="{
            'z-index': yearList.length + 3 - index,
          }"
          v-for="(item, index) in yearList"
          :key="index"
          @click="yearSelest(index)"
        >
          {{ item.Name }}
        </div>
      </div>
      <div class="List">
        <div
          :class="['grade', CycleIndex == index ? 'gradeActive' : '']"
          :style="{
            'z-index': CycleList.length + 3 - index,
          }"
          v-for="(item, index) in CycleList"
          :key="index"
          @click="CycleSelect(index)"
        >
          {{ item.Name }}
        </div>
      </div>
      <div class="List">
        <div
          :class="['grade', classIndex == index ? 'gradeActive' : '']"
          :style="{
            'z-index': classList.length + 3 - index,
          }"
          v-for="(item, index) in classList"
          :key="index"
          @click="ClassSlect(index)"
        >
          {{ item.Name }}
        </div>
      </div>
      <div class="btnList">
        <el-input
          size="mini"
          placeholder="请输入孩子姓名"
          style="width: 300px"
          v-model="studentName"
        />
        <el-button
          size="mini"
          @click="FrontGetStudentListByTermParent"
          type="primary"
          >查询</el-button
        >
        <el-button
          size="mini"
          type="primary"
          @click="batchCreateFn"
          v-if="userInfo.UserIdentity.indexOf('2') != -1"
          >批量创建</el-button
        >
      </div>
    </div>
    <div>
      <div class="studentBox">
        <div
          v-for="(item, index) in studentList"
          :key="index"
          class="item-box"
          @click="onClickAdd(item)"
        >
          <img
            v-if="item.Sex == 0"
            src="../../assets/children-girl.png"
            style="width: 72px; height: 72px"
            alt=""
          />
          <img
            v-if="item.Sex == 1"
            src="../../assets/children-boy.png"
            style="width: 72px; height: 72px"
            alt=""
          />
          <div class="item-name">{{ item.StudentName }}</div>
        </div>
      </div>
    </div>
    <!-- 批量创建 -->
    <el-dialog title="批量创建" :visible.sync="batchCreate" width="40%">
      <div class="batchCreateBody">
        <el-form ref="form" label-width="100px">
          <el-form-item label="日期选择：">
            <el-date-picker
              v-model="moduleFrom.time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy/MM/dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="记录人：">
            <el-input style="width: 350px" v-model="moduleFrom.name" />
          </el-form-item>
          <div class="moduleList">
            <div>
              <div style="text-align: right">
                模块开关： <span style="color: red">(可拖动调整顺序)</span>
              </div>
              <div>
                批量开启/关闭：
                <el-switch
                  v-model="isAllClose"
                  active-color="#13ce66"
                  inactive-color="#cccccc"
                  @change="AllCloseChange"
                >
                </el-switch>
              </div>
              <el-button type="primary" size="mini" @click="addModule"
                >添加领域</el-button
              >
            </div>
          </div>

          <div
            class="moduleItem"
            style="cursor: text"
            v-for="item in moduleListStart"
            :key="item.Id"
          >
            <div style="flex: 1">{{ item.Name }}</div>
          </div>
          <draggable
            v-model="moduleList"
            chosenClass="chosen"
            forceFallback="true"
            group="people"
            animation="500"
            :handle="'.time_img'"
          >
            <transition-group>
              <div
                class="moduleItem"
                v-for="(item, index) in moduleList"
                :key="item.Id"
              >
                <div style="flex: 1">{{ item.Name }}</div>
                <div class="delete">
                  <img
                    src="@/assets/delete.png"
                    style="width: 30px; height: 30px"
                    @click="deleteItem(index)"
                    v-if="item.Id == 0"
                    alt=""
                  />
                </div>
                <img
                  class="time_img"
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2023-3/2023-3-17/20230317144706_3813.png"
                  alt=""
                />
                <el-switch
                  v-model="item.isCheck"
                  active-color="#13ce66"
                  inactive-color="#cccccc"
                >
                </el-switch>
              </div>
            </transition-group>
          </draggable>
          <div
            class="moduleItem"
            style="cursor: text"
            v-for="item in moduleListEnd"
            :key="item.Id"
          >
            <div style="flex: 1">{{ item.Name }}</div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchCreate = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="isLoading"
          @click="CreateProceByClassFn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAcademicSelect,
  GetClassSelect,
  GetGradeList,
  GetOpenCycleInfoSelectResult,
  FrontGetStudentListByTermParent,
  FrontCreateProceByClass,
  FrontGetProceList,
} from "@/api/api";

import draggable from "vuedraggable";

export default {
  data() {
    return {
      userInfo: {}, //UserIdentity  0:管理员   1:园长   2:教师   3:家长
      yearList: [],
      yearIndex: 0,
      GradeList: [],
      GradeIndex: 0,
      classList: [],
      classIndex: 0,
      CycleList: [],
      CycleIndex: 0,
      tableData: [],
      tableHeader: [],
      studentList: [],
      studentName: "",
      batchCreate: false, //批量创建
      isAllClose: true,
      moduleFrom: {
        time: [],
        name: "",
      },
      moduleListStart: [],
      moduleList: [],
      moduleListEnd: [],
      isLoading: false,
    };
  },
  components: {
    draggable,
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    this.getAcademicSelect();
  },
  methods: {
    AllCloseChange(e) {
      this.moduleList.forEach((item) => {
        item.isCheck = e;
      });
    },
    //   跳转添加过程性评价
    onClickAdd(item) {
      let dataInfo = {
        StudentId: item.StudentId,
        CycleId: this.CycleList[this.CycleIndex].Id,
        IsBaby: this.CycleList[this.CycleIndex].IsBaby,
        BabyLevel: this.CycleList[this.CycleIndex].BabyLevel,
        StudentName: item.StudentName,
      };
      this.$router.push({
        path: "/addProcessEvaluate",
        query: {
          dataInfo: escape(JSON.stringify(dataInfo)),
        },
      });
    },
    //   添加维度
    addModule() {
      let that = this;
      this.$prompt("添加维度", {
        confirmButtonText: "保存添加",
        cancelButtonText: "取消添加",
        inputPlaceholder: "请输入维度名称(最多6个字符)",
      }).then(({ value }) => {
        if (value == null || value.length == 0) {
          that.$message({
            type: "error",
            message: "请输入维度名称",
          });
        } else if (value.length > 6) {
          that.$message({
            type: "error",
            message: "维度名称最多6个字符",
          });
        } else {
          that.moduleList.unshift({
            Id: 0,
            Img: "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/202105171457245.JPEG",
            Name: value,
            Status: 1,
            Type: 3,
            isCheck: true,
          });
          // that.moduleList.unshift(end)
        }
      });
    },
    // 获取维度列表
    async GetProceList() {
      this.moduleFrom.name = JSON.parse(
        window.localStorage.getItem("user")
      ).name;
      let xhr = await FrontGetProceList({
        IsBaby: this.CycleList[this.CycleIndex].IsBaby,
        BabyLevel: this.CycleList[this.CycleIndex].BabyLevel,
      });
      if (xhr.data.success) {
        xhr.data.response.forEach((element) => {
          element.isCheck = true;
        });
        this.moduleList = xhr.data.response.filter((item) => {
          return (
            item.Type == 3 || item.Type == 4 || item.Type == 5 || item.Type == 2
          );
        });
        this.moduleListStart = xhr.data.response.filter((item) => {
          return item.Type == 1;
        });

        //console.log(this.moduleListStart, "this.moduleListStart");
        this.moduleListEnd = xhr.data.response.filter((item) => {
          return item.Type == 6;
        });
      }
    },
    //   批量评价
    async CreateProceByClassFn() {
      this.isLoading = true;
      if (this.moduleFrom.time.length == 0) {
        this.$message.error("请填写日期");
        this.isLoading = false;
        return;
      }
      if (this.moduleFrom.name == "") {
        this.$message.error("请填写记录人");
        this.isLoading = false;
        return;
      }
      this.batchCreate = false;
      this.moduleList.forEach((item) => {
        if (item.isCheck) {
          item.status = 1;
        } else {
          item.status = 0;
        }
      });
      console.log([
        ...this.moduleListStart,
        ...this.moduleList,
        ...this.moduleListEnd,
      ]);
      let xhr = await FrontCreateProceByClass({
        CycleId: this.CycleList[this.CycleIndex].Id,
        StudyYearId: this.yearList[this.yearIndex].Id,
        ClassId: this.classList[this.classIndex].Id,
        Title: this.moduleFrom.time.join("-"),
        WriteName: this.moduleFrom.name,
        proceInfo: [
          ...this.moduleListStart,
          ...this.moduleList,
          ...this.moduleListEnd,
        ],
      });
      this.isLoading = false;
      if (xhr.data.success) {
        this.$message.success("创建成功");
      } else {
        this.$message.success(xhr.data.msg);
      }
    },
    //   批量创建
    batchCreateFn() {
      this.GetProceList();
      this.batchCreate = true;
    },
    //   获取学生列表
    async FrontGetStudentListByTermParent() {
      let xhr = await FrontGetStudentListByTermParent({
        StudentName: this.studentName ? this.studentName : undefined,
        StudyYearId: this.yearList[this.yearIndex].Id,
        CycleId: this.CycleList[this.CycleIndex].Id,
        ClassId: this.classList[this.classIndex].Id,
        IsBaby: this.CycleList[this.CycleIndex].IsBaby,
        BabyLevel: this.CycleList[this.CycleIndex].BabyLevel,
      });
      if (xhr.data.success) {
        this.studentList = xhr.data.response;
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    // 获取学界
    async getAcademicSelect() {
      let UserIdentityArr = this.userInfo.UserIdentity.split(";");
      let isKindergarten = UserIdentityArr.find((item) => {
        return item == 1;
      });
      let xhr = await getAcademicSelect({
        Uid: this.userInfo.uID,
        SchoolId: this.userInfo.SchoolId,
        Type: isKindergarten ? 3 : 2, //EvaluationType==2 1学生、2教师、3校长、4家长
      });
      if (xhr.data.success) {
        this.yearList = xhr.data.response;
        this.yearIndex = 0;
        if (this.yearList.length != 0) {
          //   this.GetGradeSelect();
          this.GetOpenCycleInfoSelectResult();
        }
      } else {
        this.yearList = [];
      }
    },

    // 获取班级列表
    async GetClassSelect() {
      let xhr = await GetClassSelect({
        StudyYearId: this.yearList[this.yearIndex].Id,
        SchoolId: this.userInfo.SchoolId,
        GradeId: this.CycleList[this.CycleIndex].GradeId, //EvaluationType==2 1学生、2教师、3校长、4家长
      });
      if (xhr.data.success) {
        this.classList = xhr.data.response;
        this.classIndex = 0;
        this.FrontGetStudentListByTermParent();
      } else {
        this.classList = [];
        this.$message.warning(xhr.data.msg);
      }
    },

    // 获取年级列表
    async GetGradeSelect() {
      let xhr = await GetGradeList({
        SchoolType: this.userInfo.SchoolType,
        SchoolId: this.userInfo.SchoolId,
        StudyYearId: this.yearList[this.yearIndex].Id,
        Uid: this.userInfo.uID,
      });
      if (xhr.data.success) {
        this.GradeList = xhr.data.response;
        this.GradeIndex = 0;
        if (this.GradeList.length != 0) {
          this.GetClassSelect();
        }
      } else {
        this.GradeList = [];
        this.$message.warning(xhr.data.msg);
      }
    },
    // 获取周期
    async GetOpenCycleInfoSelectResult() {
      let xhr = await GetOpenCycleInfoSelectResult({
        SchoolId: this.userInfo.SchoolId,
        StudyYearsId: this.yearList[this.yearIndex].Id,
      });
      if (xhr.data.success) {
        this.CycleList = xhr.data.response;
        this.CycleIndex = 0;
        if (this.CycleList.length) {
          await this.GetClassSelect();
        }
      } else {
        this.CycleList = [];
        this.classList = [];
        this.$message.warning(xhr.data.msg);
      }
    },
    yearSelest(index) {
      this.yearIndex = index;
      this.GetOpenCycleInfoSelectResult();
    },
    GradeSelect(index) {
      this.GradeIndex = index;
      this.GetClassSelect();
    },

    ClassSlect(index) {
      this.classIndex = index;
      this.FrontGetStudentListByTermParent();
    },

    CycleSelect(index) {
      this.CycleIndex = index;
      this.GetClassSelect();
    },
  },
};
</script>

<style lang="less" scoped>
.time_img {
  margin-right: 20px;
}
.List {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .grade {
    position: relative;
    display: inline-block;
    min-width: 145px;
    height: 30px;
    border: 1px solid #cdcdcd;
    background: #e5ebff;
    border-radius: 15px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    padding: 0 20px;
    box-sizing: border-box;
    line-height: 30px;
    color: #333333;
    cursor: pointer;
  }

  .gradeActive {
    color: #ffffff;
    background: #5474e6;
    border: 1px solid #5474e6;
  }
}
/deep/.el-dialog {
  border-radius: 10px;
  overflow: hidden;
}
/deep/.el-dialog__header {
  background: #f2f5ff;
}
.echartBox {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
  .studentListBox {
    width: 200px;
    height: 400px;
    border: #ccc 1px solid;
    border-radius: 20px;
    overflow: hidden;
    .studentList {
      width: 220px;
      height: 420px;
      padding: 10px;
      overflow: scroll;
      box-sizing: border-box;
      .studentItem {
        height: 20px;
        display: flex;
        align-items: center;
        font-size: 14px;
      }
      .studentItem div:nth-child(1) {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
  }
}
.filtrateBox {
  background-color: #ffffff;
  padding: 20px;
  margin-bottom: 10px;
}
.contentBox {
  margin-top: 20px;
  background-color: #ffffff;
  padding: 20px;
  box-sizing: border-box;
}
.List {
  display: flex;
  div {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.btnList {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  div {
    margin-right: 10px;
  }
}
.elPopoverTable {
  cursor: pointer;
}

.item-box {
  width: 129px;
  height: 150px;
  background: #f2f5ff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 10px;
  justify-content: center;
  .item-name {
    font-size: 16px;
    font-weight: 600;
    color: #033333;
    padding: 10px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
  }
}
.studentBox {
  flex-wrap: wrap;
  display: flex;
  padding: 20px;
  margin-top: 10px;
  background-color: #ffffff;
}
.moduleItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 90px;
  border-bottom: 1px #dcf0ff dashed;
  cursor: move;
  height: 40px;
}
.moduleList > div:nth-child(1) {
  display: flex;
  justify-content: space-between;
}
</style>